export default {
  init() {
    // JavaScript to be fired on all pages
      jQuery('.search__icon').click(function () {
        //jQuery('.banner__search').slideToggle();
          jQuery('.banner__search').toggleClass('open__search');
      });

      jQuery('.form__input .cv').append('<span class="newfile">Choose a file</span>');
      var inputs = document.querySelectorAll( '.cv' );
      Array.prototype.forEach.call( inputs, function( input )
      {
          var label	 = input.nextElementSibling,
              labelVal = label.innerHTML;

          input.addEventListener( 'change', function( e )
          {
              var fileName = '';
              if( this.files && this.files.length > 1 )
                  fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
              else
                  fileName = e.target.value.split( '\\' ).pop();

              if( fileName )
                  //label.querySelector( 'span.newfile' ).innerHTML = fileName;
                  jQuery('span.newfile').html(fileName);
              else
                  label.innerHTML = labelVal;
          });
      });


      var search = jQuery('.banner__search-mobile').html();
      jQuery('.banner__search-mobile').remove();
      jQuery('#popout ul.banner__menu').append('<li class="banner__search-mobile">' + search + '</li>');


      jQuery.each(jQuery('.banner__menu li') ,function(){
          var tipo;
          var classNames = jQuery(this).attr("class").toString().split(' ');
          jQuery.each(classNames, function (i, className) {
              if(className.indexOf('menu-item-object-') != -1){
                  tipo = className.replace('menu-item-object-','');
              }
          });

          if(tipo!='page' && tipo != 'undefined' && tipo != '' && tipo != undefined) {
              jQuery(this).append('<a href="#" class="open__submenu" data-submenu="' + tipo + '"></a>');
              jQuery(this).append(jQuery('ul.submenu-' + tipo + '-menu'));
              if(jQuery(this).hasClass('current-menu-item')) {
                  jQuery(this).children('a').addClass('no-current');
              }
          }

      });

      jQuery.each(jQuery('.menu-item'), function(){
         if(jQuery(this).hasClass('current-menu-item')){
             var submenu =jQuery(this).children('.open__submenu');
             var tipo=submenu.attr('data-submenu');
             //jQuery(this).children('a:first-child').addClass('sub__menu-line');
             submenu.addClass('sub__menu-rotation');
             jQuery('ul.submenu-'+tipo+'-menu').addClass('sub__menu-display');
         }
      });

      jQuery('.open__submenu').on('click',function(){
          var tipo=jQuery(this).attr('data-submenu');
          jQuery('.sub__menu').removeClass('sub__menu-display');
          //jQuery('.menu-item a').removeClass('sub__menu-line');
          if(jQuery(this).hasClass('sub__menu-rotation')){
              jQuery('.open__submenu').removeClass('sub__menu-rotation');
              jQuery('ul.submenu-'+tipo+'-menu').removeClass('sub__menu-display');
              //jQuery(this).parent().children('a:first-child').removeClass('sub__menu-line');
          }else{
              //jQuery(this).parent().children('a:first-child').addClass('sub__menu-line');
              jQuery('.open__submenu').removeClass('sub__menu-rotation');
              jQuery(this).addClass('sub__menu-rotation');
              jQuery('ul.submenu-'+tipo+'-menu').addClass('sub__menu-display');
          }

      });

      jQuery(".notizie__sinistra .paginaIntera_article").dotdotdot({
          //	configuration goes here
          ellipsis	: ' [...]',
          // after: "a.readmore",
      });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js